import { useEffect, useState } from 'react';
import { useAppSelector } from '../../hooks/hooks';
import { t } from '../../utilities/translator';
import { getParamFromUrl } from '../../utilities/urlResolver'
import { WIZARD_UNSUPPORTED_SEARCH_DISPLAYED } from '../../constants/analyticEvents';
import { pushEvent } from '../../utilities/analytics';
import useBodyScrollLock from '../../hooks/useBodyScrollLock';
import FadeTransition from '../../components/animations/FadeTransition';

const UnsupportedSearch = () => {
  const [showModal, setShowModal] = useState(false);
  const unsupportedSearch = getParamFromUrl('unsupportedSearch');
  const unsupportedReasonId = getParamFromUrl('unsupportedReasonId');
  const { show: showWizard, formV2 } = useAppSelector(state => state.onboarding);

  useBodyScrollLock({ condition: showModal, mobileOnly: true });

  useEffect(() => {
    if (showModal) {
      pushEvent(WIZARD_UNSUPPORTED_SEARCH_DISPLAYED, {
        message: t(`onboarding.assistant.unsupportedSearch.message${unsupportedReasonId}`),
        prompt: formV2.prompt,
        response: window.location.hash,
      });
    }
  }, [showModal, formV2.prompt, formV2.whisper])

  useEffect(() => {
    if (showWizard || !unsupportedSearch || !unsupportedReasonId) {
      setShowModal(false);
    } else {
      setShowModal(true);
    }
  }, [unsupportedSearch, unsupportedReasonId, showWizard])

  const updateSearch = () => {
    setShowModal(false);
    const url = new URL(window.location.href);
    url.hash = url.hash
      .split('&')
      .filter(param => !param.includes('unsupportedSearch') && !param.includes('unsupportedReasonId'))
      .join('&');
    window.history.replaceState(null, '', url.toString());
  }

  const refreshSearch = () => {
    window.location.href = window.location.origin + '?startWizard=true#startWizard=true';
  }

  return (
    <FadeTransition in={showModal} timeout={200} unmountOnExit>
      <div className="unsupported-search">
        <div className="overlay" />
        <FadeTransition in={showModal} timeout={200} unmountOnExit>
          <div className="assistant-v2__panel slide-in-bottom-v2 z-[1000] text-center">
            {[1, 3, 5].includes(Number(unsupportedReasonId)) && <div className="text-xl font-semibold">{t('onboarding.assistant.unsupportedSearch.title1')}</div>}
            {[2, 4].includes(Number(unsupportedReasonId)) && <div className="text-xl font-semibold">{t('onboarding.assistant.unsupportedSearch.title2')}</div>}

            <div className="font-medium">{t(`onboarding.assistant.unsupportedSearch.message${unsupportedReasonId}`)}</div>
            {[1, 3, 5].includes(Number(unsupportedReasonId)) && <button onClick={updateSearch}>{t('onboarding.assistant.unsupportedSearch.keepSearchBtn')}</button>}
            {[2, 4].includes(Number(unsupportedReasonId)) && <button onClick={refreshSearch}>{t('onboarding.assistant.unsupportedSearch.newFeedBtn')}</button>}
          </div>
        </FadeTransition>
      </div>
    </FadeTransition>
  )
}

export default UnsupportedSearch
